import React,{useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

const OrderReview = () => {
    const [updateList, setUpdateList] = useState([]);
    const [show, setShow] = useState(0);
    const [orderInfo, setOrderInfo] = useState([]);
    const location = useLocation();
    const id = location.search.split('=');
    const searchid = Number(id[1]);
    const subjectList = ['order_company','material','material_weight','material_price','due_date','deposit','deposit_price','deposit_day','deposit_send','delivery','delivery_date','position','purchaser','statement','result','note','hide'];
    const renameSubject = ['발주처변경','품명변경','수량변경','단가변경','납기요청일변경','선입금입력','선입금입력','입금여부변경','입금금액변경','배송변경','배송출발일','재고위치변경','구매업체변경','명세서등록','완료처리','비고변경','숨김처리'];
    const OrderCheckList = async() => {
        const OrderInfo = await axiosInstance.get(`/orderboard/orderinfo?searchid=${searchid}`);
            setOrderInfo([...OrderInfo.data]);
      }
    useEffect(()=>{OrderCheckList();},[])

    const viewData = (_showData) => {
      return _showData === 0 ? setShow(1) : setShow(0);
    }
    return(
        <div>
            <table className='table_normal' style={{marginLeft:'30px',marginTop:'30px'}}>
                <thead>
                    <tr>
                        <th colSpan={4}>
                            <Button onClick={()=>viewData(show)} size='small' variant="contained" color={show === 0 ? 'success' : 'primary'} style={{width:'100%'}} >
                            {show === 0 ? 'View Changed Data' : 'Hide Data'}
                            </Button>
                        </th>    
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>발주업체</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>요청원료</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>수량</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>단가</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>선입금업체</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>선입금 <br></br>요청 금액</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>선입금 입금일</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>선입금 <br></br>확인 금액</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>업체납품<br></br>요청일</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>명세서 출력</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>구매업체</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>납품자</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>배송출발일</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>재고위치</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>기타사항</th>
                        <th rowSpan={2} className={show === 0 ? 'hide' : ''}>납품완료</th>
                    </tr>
                    <tr>
                        <th rowSpan={1}>번호</th>
                        <th rowSpan={1}>변경 일자/시간</th>
                        <th rowSpan={1}>작성자</th>
                        <th rowSpan={1}>변경항목</th>
                    </tr>
                </thead>
                <tbody>
                {orderInfo.map((data,i)=>
                <tr key={data.id}>
                    <td>{i+1}</td>
                    <td>{data.inputdate.substring(2,10)+' / '+data.inputdate.substring(11,19)}</td>
                    <td>{data.username}</td>
                    <td>{data.subject}</td>
                    <td align='left' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'order_company' ? 'backgroundyellow' : '' }>{data.order_company}</td>
                    <td align='left' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'material' ? 'backgroundyellow' : ''}>{data.material}</td>
                    <td align='right' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'material_weight' ? 'backgroundyellow' : ''}>{data.material_weight}</td>
                    <td align='right' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'material_price' ? 'backgroundyellow' : ''}>{data.material_price}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'deposit' ? 'backgroundyellow' : ''}>{data.deposit}</td>
                    <td align='right' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'deposit_price' ? 'backgroundyellow' : ''}>{data.deposit_price}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'deposit_day' ? 'backgroundyellow' : ''}>{data.deposit_day}</td>
                    <td align='right' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'deposit_send' ? 'backgroundyellow' : ''}>{data.deposit_send}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'due_date' ? 'backgroundyellow' : ''}>{data.due_date.substring(0,10)}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'statement' ? 'backgroundyellow' : ''}>{data.statement.substring(0,10) === '9999-01-01' ? '미입력' : data.statement.substring(0,10)}</td>
                    <td align='left' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'purchaser' ? 'backgroundyellow' : ''}>{data.purchaser}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'delivery' ? 'backgroundyellow' : ''}>{data.delivery}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'delivery_date' ? 'backgroundyellow' : ''}>{data.delivery_date}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'position' ? 'backgroundyellow' : ''}>{data.position}</td>
                    <td align='left' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'note' ? 'backgroundyellow' : ''}>{data.note}</td>
                    <td align='center' className={show === 0 ? 'hide' : subjectList[renameSubject.indexOf(data.subject)] === 'result' ? 'backgroundyellow' : ''}>{data.result}</td>
                </tr>
                )       
                }
                </tbody>
            </table>
        </div>
    )

}
export default OrderReview;